export const generateAgenciesArray = (arrAgencies, arrWeeks, paddingValue) => {
  const agenciesHeader = [];
  arrAgencies.forEach((agency) => {
    for (let i = 0; i < arrWeeks.length; i ++) {
      agenciesHeader.push(agency);
    }
    agenciesHeader.push(paddingValue);
  });
  return agenciesHeader;
};

export const generateWeeksArray = (arrAgencies, arrWeeks, paddingValue) => {
  const weeksHeader = [];
  for (let i = 0; i < arrAgencies.length; i ++) {
    arrWeeks.forEach((week) => {
      weeksHeader.push(week);
    });
    weeksHeader.push(paddingValue);
  }
  return weeksHeader;
};

export const fillHeader = (arrAgencies, arrWeeks) => {
  const agencyHeader = generateAgenciesArray(arrAgencies, arrWeeks, '');
  const weeksHeader = generateWeeksArray(arrAgencies, arrWeeks, 'TOTAL');
  return [agencyHeader, weeksHeader];
};

function fillTable(modelsLen, rowLen) {
  const result = [];

  for (let i = 0; i < modelsLen; i++) {
    const row = [];
    for (let y = 0; y < rowLen; y++) {
      row.push(0);
    }
    result.push(row);
  }

  return result;
}

function createTable(models, table) {
  return models.map((model, idx) => [model, ...table[idx]]);
}

export const createData = (models, agencies, weeks) => {
  const newModels = ['', 'MODELOS', ...models, 'TOTAL'];
  const MODELSLEN = newModels.length;
  const header = fillHeader(agencies, weeks);
  const ROWLEN = header ? header[0].length : 0;
  const fillTableZeros = fillTable(MODELSLEN, ROWLEN);
  const mergeHeaderTableZeros = [...header, ...fillTableZeros];
  const table = createTable(newModels, mergeHeaderTableZeros);

  return table;
};
